// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import petitionMilestoneEntity from './entities/petition-milestone.json';
import petitionMilestoneMenu from '../pages/petition-milestone/menu.json';
import petitionMilestoneFullForm from '../pages/petition-milestone/forms/full.json';
import petitionMilestoneContextForm from '../pages/petition-milestone/forms/context.json';
import petitionMilestoneMiniForm from '../pages/petition-milestone/forms/mini.json';
import petitionMilestoneLookupForm from '../pages/petition-milestone/forms/lookup.json';
import petitionMilestoneTableView from '../pages/petition-milestone/views/table.json';
import petitionMilestoneCardsView from '../pages/petition-milestone/views/cards.json';
import petitionMilestoneCalendarView from '../pages/petition-milestone/views/calendar.json';
import petitionMilestoneDashboardView from '../pages/petition-milestone/views/dashboard.json';

/** Тип запису «Етап петиції» зі сторінками пакета: меню, форми та подання з pages/petition-milestone/. */
export const petitionMilestoneDefinition: IRecordTypeDefinition = {
  ...petitionMilestoneEntity,
  views: assembleViewSet({
      table: petitionMilestoneTableView,
      cards: petitionMilestoneCardsView,
      calendar: petitionMilestoneCalendarView,
      dashboard: petitionMilestoneDashboardView,
  }),
  form: petitionMilestoneFullForm,
  forms: { full: petitionMilestoneFullForm, context: petitionMilestoneContextForm, mini: petitionMilestoneMiniForm, lookup: petitionMilestoneLookupForm },
  menu: petitionMilestoneMenu,
} as IRecordTypeDefinition;
